<template>
  <div class="CWareOrder">
    <!-- 搜索框 -->
    <div class="searchBox">
      <el-input class="searchInput" placeholder="订单号" v-model="keyword.number" clearable @keyup.enter.native="StorageOrder(1)"></el-input>
      <el-input class="searchInput" placeholder="设备ID" v-model="keyword.deviceId" clearable @keyup.enter.native="StorageOrder(1)"></el-input>
      <el-select v-model="keyword.status" placeholder="状态" clearable @change="StorageOrder(1)">
        <el-option :label="item.name" :value="item.id" v-for="(item,index) in statusList" :key="index"></el-option>
      </el-select>
      <el-button class="searchBtn" type="primary" @click="StorageOrder(1)">搜 索</el-button>
    </div>

    <el-table v-loading="loading" :data="tableData" style="width: 100%">
      <el-table-column type="index" label="序号" width="80" fixed></el-table-column>
      <el-table-column label="订单号" prop="Id" fixed></el-table-column>
      <el-table-column label="入库单号" prop="ReceiptNo" fixed></el-table-column>
      <el-table-column label="快递单号" prop="CourierNo" fixed></el-table-column>
      <el-table-column label="开门密码" prop="OpenPw" fixed></el-table-column>
      <el-table-column label="发件人" prop="SendPhone"></el-table-column>
      <el-table-column label="收件人" prop="ReceiverPhone"></el-table-column>
      <el-table-column label="设备ID" prop="DeviceId"></el-table-column>
      <el-table-column label="货位号" prop="LocationNo"></el-table-column>
      <el-table-column label="订单状态">
        <template slot-scope="scope">
          <span v-if="scope.row.Status == '1'">已预约入库</span>
          <span v-else-if="scope.row.Status == '2'">已入库</span>
          <span v-else-if="scope.row.Status == '3'">已预约出库</span>
          <span v-else>已出库</span>
        </template>
      </el-table-column>
      <el-table-column label="入库时间" prop="Time"></el-table-column>
    </el-table>
    <div class="paging" v-if="total>limits">
      <el-pagination
        @current-change="CurrentChange"
        :current-page.sync="curr"
        :page-size="limits"
        layout="prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    

  </div>
</template>
<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"
  import { bussinessApi } from "../../../../../static/js/api.js"
  var vm
  export default {
    name:'CWareOrder',
    data(){
      return {
        //搜索
        keyword:{
          number:'',//订单号
          deviceId:'',//设备ID
          status:'',//状态
        },
        statusList:[{
          id:'1',
          name:'已预约入库'
        },{
          id:'2',
          name:'已入库'
        },{
          id:'3',
          name:'已预约出库'
        },{
          id:'4',
          name:'已出库'
        }],

        loading:false,//表格刷新
        tableData:[{
          id:'1'
        }],//表格数据

        //分页
        curr:1,
        limits:10,
        total:10,

      }
    },
    components: {
      CBreadCrumb,
    },
    async created(){
      vm = this
      this.StorageOrder()
    },
    methods:{

      //仓储订单列表
      async StorageOrder(curr,limits){
        const data = {
          'OrderId': vm.keyword.number,//订单号
          'DeviceId':vm.keyword.deviceId,//设备号
          'Status': vm.keyword.status,//状态
          'Curr': curr ? curr : vm.curr,
          'Limits': limits ? limits :vm.limits,
        }
        this.loading = true
        const res = await bussinessApi.StorageOrder(data)
        this.loading = false
        if(res.ErrCode == 0){
          vm.tableData = res.Result.list
          vm.curr = parseInt(res.Result.Curr)
          vm.tatal = parseInt(res.Result.Total)
        }else{
          showToast(res.ErrMsg)
        }
      },
      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
        this.StorageOrder(val)
      },
    },
  }
</script>
<style lang="scss">
.CWareOrder{
  padding: 24px;
  
  .w100{
    width: 100px;
  }
  .w300{
    width: 300px;
  }
  .searchBox {
    margin-bottom: 20px;
    .searchInput {
      width: 200px;
    }
  }
  .contDio{
    .info{
      span{
        margin-right: 30px;
        margin-bottom: 10px;
        display: inline-block;
      }
    }
    .foot{
      text-align: right;
      margin-top: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Page/CStorage/COutInWareManage/CWareOrder.vue